import React from 'react';

import Link from 'ui-library/Link';

import {GibsonEndpoint} from '../BulkAssemblyConstants';
import PositionalEndpointOptions from './PositionalEndpointOptions';

interface Props {
  endpoint: GibsonEndpoint;
  onEndpointChange: (changes: {position: number} | {bases: string}) => void;
  onOpenPrimerSettings: () => void;
}

function GibsonSlotEndpoint({endpoint, onEndpointChange, onOpenPrimerSettings}: Props): JSX.Element {
  return (
    <div>
      <PositionalEndpointOptions
        endpoint={endpoint}
        handlePositionalEndpointChange={(changes: {position: number} | {bases: string}) => {
          onEndpointChange(changes);
        }}
      />
      <Link onClick={onOpenPrimerSettings}>Primer settings</Link>
    </div>
  );
}

export default GibsonSlotEndpoint;
